import React from "react"
import Industrial from "../../components/pages/development/industrial"

const IndustrialPage = (props) => <Industrial {...props} />

export default IndustrialPage